export default __webpack_public_path__ + "static/media/Horosz.604c9e35.jpg";